var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTemplates(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 16.2503C16.3867 16.2503 16.6667 15.9707 16.6667 15.6253V3.54199C16.6667 2.50824 15.8255 1.66699 14.7917 1.66699H5.20837C4.17462 1.66699 3.33337 2.50824 3.33337 3.54199V16.4587C3.33337 17.4924 4.17462 18.3337 5.20837 18.3337H16.0417C16.3867 18.3337 16.6667 18.0541 16.6667 17.7087C16.6667 17.3632 16.3867 17.0837 16.0417 17.0837H5.20837C4.86379 17.0837 4.58337 16.8032 4.58337 16.4587V16.2503H16.0417ZM7.29171 5.83366H12.7084C13.0534 5.83366 13.3334 6.11324 13.3334 6.45866C13.3334 6.80408 13.0534 7.08366 12.7084 7.08366H7.29171C6.94671 7.08366 6.66671 6.80408 6.66671 6.45866C6.66671 6.11324 6.94671 5.83366 7.29171 5.83366Z",
    fill: "#FFFCEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTemplates);
export default __webpack_public_path__ + "static/media/ic_templates.c64d7091d49aa6208568dc3f42f2036d.svg";
export { ForwardRef as ReactComponent };